import { Alert } from 'components/ui';
import type { SignInAlertsProps } from './SignInAlerts.types';

const SignInAlerts = ({
  authErrorAlertContent,
  authRequirementsError,
  dismissAuthError,
  dismissRequirementsError,
  isRequirementsErrorDismissed,
}: SignInAlertsProps) => (
  <>
    {authErrorAlertContent ? (
      <Alert onClose={dismissAuthError} severity="error" visualVariant="inlineError">
        {authErrorAlertContent}
      </Alert>
    ) : null}
    {authRequirementsError && !isRequirementsErrorDismissed ? (
      <Alert onClose={dismissRequirementsError} severity="error" visualVariant="inlineError">
        {authRequirementsError}
      </Alert>
    ) : null}
  </>
);

export default SignInAlerts;
